// useNavRef hook to track pathnames so that Journey tab is highlighted on any Journey path.

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';

const JOURNEY_PATHS = [
  getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
  getModulePath(LEAGUE_MODULE_NAMES.healthJourneyHistory),
  getModulePath(LEAGUE_MODULE_NAMES.healthPrograms),
  getModulePath(LEAGUE_MODULE_NAMES.healthProgress),
  getModulePath(LEAGUE_MODULE_NAMES.careLibrary),
];

const isPathActiveOverride = (navLinkPathname: string, currentPath: string) => {
  if (navLinkPathname === getModulePath(LEAGUE_MODULE_NAMES.healthJourney)) {
    return JOURNEY_PATHS.some((path) => currentPath.startsWith(path));
  }
  return false;
};

export const useNavRef = (navLinkPathname: string) => {
  const navRef = useRef<HTMLAnchorElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (navRef.current) {
      const isCurrentPage =
        location.pathname.startsWith(navLinkPathname) ||
        isPathActiveOverride(navLinkPathname, location.pathname);
      if (isCurrentPage) {
        navRef.current.setAttribute('aria-current', 'page');
        navRef.current.classList.add('active');
      } else {
        navRef.current.removeAttribute('aria-current');
        navRef.current.classList.remove('active');
      }
    }
  }, [location.pathname, navLinkPathname]);

  return navRef;
};
